import { Button, FormProps, message } from 'antd'
import { Input } from 'antd'
import { Form } from 'antd'
import Container from '../../components/Layout/Container'
import styles from './contact-section.module.css'
import { Select } from 'antd'
import { Row, Col } from 'antd'
import { useState } from 'react'
import { Thanks } from './Thanks'

type FieldType = {
    firstName: string;
    lastName: string;
    email: string;
    company: string;
    inquiryType: string;
    message: string;
};

export const ContactUs = () => {

    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const onFinish: FormProps<FieldType>['onFinish'] = async (values: FieldType) => {

        try {
            setIsLoading(true);
            const response = await fetch('/api/contact', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    type: "Contacts",
                    firstName: values.firstName?.trim(),
                    lastName: values.lastName?.trim(),
                    email: values.email?.trim(),
                    company: values.company?.trim(),
                    inquiryType: values.inquiryType?.toString(),
                    message: values.message?.trim(),
                }),
            });
            const data = await response.json();
            if (data.success) {
                setIsSubmitted(true);
                window.scrollTo({ top: 0, behavior: "smooth" });
            } else {
                message.error("Something went wrong, please try again later.");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = () => {
        message.error("Oops! Something went wrong. Please try again.");
    };

    if (isSubmitted) return <Thanks title="Thanks for Reaching Out!" subtitle="We’ve received your message and will get back to you shortly. Our team is here to help and typically responds within 24-48 hours." />;
    return (
        <section>
            <div className={styles.container}>
                <Container>
                    <div className={styles.wrapper}>
                        <div className={styles.grid}>
                            {/* Left Column */}
                            <div className={styles.leftColumn}>
                                <div>
                                    <span className={styles.tag}>Let&apos;s Talk</span>
                                    <h2 className={styles.title}>
                                        Whether you&apos;re a potential business partner, investor, or simply interested in learning more about Moodra, we&apos;d love to connect with you!
                                    </h2>
                                    <p className={styles.subtitle}>
                                        Don&apos;t miss your chance to be a trailblazer with Moodra — reach out and let&apos;s shape the future together!
                                    </p>
                                </div>
                            </div>

                            {/* Right Column */}
                            <div>
                                <div className={styles.card}>
                                    <div className={styles.formWrapper}>
                                        <h3 className={styles.formTitle}>Contact with us</h3>
                                        <Form
                                            name="contactForm"
                                            layout="vertical"
                                            onFinish={onFinish}
                                            onFinishFailed={onFinishFailed}
                                            autoComplete="off"
                                            requiredMark={false}
                                        >
                                            <Row gutter={16}>
                                                <Col xs={24} xl={12}>
                                                    <Form.Item
                                                        name="firstName"
                                                        label="First Name*"
                                                        rules={[{ required: true, message: 'Please input your first name!' }]}
                                                    >
                                                        <Input placeholder="Jane" size='large' />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} xl={12}>
                                                    <Form.Item
                                                        name="lastName"
                                                        label="Last Name*"
                                                        rules={[{ required: true, message: 'Please input your last name!' }]}
                                                    >
                                                        <Input placeholder="Smith" size='large' />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Form.Item
                                                name="email"
                                                label="Email*"
                                                rules={[{ required: true, message: 'Please input your email!', type: 'email' }]}
                                            >
                                                <Input placeholder="janesmith@gmail.com" size='large' />
                                            </Form.Item>
                                            <Form.Item
                                                name="company"
                                                label="Company"
                                            >
                                                <Input placeholder="Your company or organization" size='large' />
                                            </Form.Item>
                                            <Form.Item
                                                name="inquiryType"
                                                label="Inquiry Type*"
                                                rules={[{ required: true, message: 'Please select an inquiry type!' }]}
                                            >
                                                <Select
                                                    mode="multiple"
                                                    placeholder="Select inquiry type"
                                                    allowClear
                                                    size='large'
                                                    showSearch={false}
                                                >
                                                    <Select.Option value="Business Partnership">Business Partnership</Select.Option>
                                                    <Select.Option value="Investment Opportunity">Investment Opportunity</Select.Option>
                                                    <Select.Option value="General Inquiry">General Inquiry</Select.Option>
                                                </Select>
                                            </Form.Item>
                                            <Form.Item
                                                name="message"
                                                label="Message*"
                                                rules={[{ required: true, message: 'Please input your message!' }]}
                                            >
                                                <Input.TextArea rows={3} size='large' placeholder="Tell us more about how we can help or work together" />
                                            </Form.Item>
                                            <Form.Item style={{ marginBottom: '20px' }}>
                                                <Button
                                                    block
                                                    type="primary"
                                                    htmlType="submit"
                                                    className="waitlist-button"
                                                    loading={isLoading}
                                                >
                                                    Submit
                                                </Button>
                                            </Form.Item>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </section>
    )
}

